module.exports = __webpack_public_path__ + "checkbeer.jpg?dbdddc0ba261e039dca201b6b2fbd0df";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/checkbeer.jpg
// module id = 109
// module chunks = 0